import { _nx, sprintf } from '@wordpress/i18n';

document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr || {};

  findstr.hooks.addAction(
    'searchResults',
    'custom-results-count',
    function (results, group, field) {
      if (field) {
        const htmlQueryCount = document.querySelector(
          '.block-listing__results-count[data-findstr-group="' + group + '"]'
        );

        if (htmlQueryCount) {
          htmlQueryCount.textContent = sprintf(
            /* translators: %s is number of results */
            _nx(
              '%s result',
              '%s results',
              results.totalHits,
              'results count',
              'vtx'
            ),
            results.totalHits
          );
        }
      }
    }
  );
});
